(function () {
  if (window.__l51SiblingsInit) return;
  window.__l51SiblingsInit = true;

  /*
   * No usamos window.PRODUCT_CARD_SECTION_ID porque Broadcast puede
   * definirla como "api-product-grid-item".
   */
  const SECTION_ID = 'api-crocs-product-item';

  /*
   * El PLP muestra el nombre corto (metacampo custom.nombre_corto) y el resto
   * de las superficies el titulo completo. La URL que se pide es la del
   * producto, asi que el endpoint no puede deducir de donde salio la tarjeta:
   * se elige aca segun la grilla que la contiene.
   */
  const SECTION_ID_PLP = 'api-crocs-product-item-plp';
  const SEL_PLP_GRID = '[data-crocs-plp-grid]';

  function getSectionId(card) {
    return card.closest(SEL_PLP_GRID)
      ? SECTION_ID_PLP
      : SECTION_ID;
  }

  const SEL_CARD = '[data-crocs-product-card]';
  const SEL_GRID = '[data-sib-grid]';
  const SEL_PDP = '[data-sib-pdp]';
  const SEL_GRID_SIBLING =
    '[data-sib-grid] .l51-sib-grid__item';

  function getStep(track) {
    if (!track) return 40;

    const item = track.querySelector('.l51-sib-grid__item');
    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);

    return item
      ? item.getBoundingClientRect().width + gap
      : 40;
  }

  function getHandleFromUrl(url) {
    try {
      const parsedUrl = new URL(url, location.origin);
      const parts = parsedUrl.pathname.split('/').filter(Boolean);
      const productIndex = parts.indexOf('products');

      return productIndex >= 0
        ? parts[productIndex + 1]
        : null;
    } catch (error) {
      return null;
    }
  }

  function updateGridState(root) {
    if (!root) return;

    const track = root.querySelector('[data-sib-grid-track]');
    const prev = root.querySelector('[data-sib-grid-prev]');
    const next = root.querySelector('[data-sib-grid-next]');

    if (!track || !prev || !next) return;

    const maxScroll = Math.max(
      0,
      track.scrollWidth - track.clientWidth
    );

    const currentScroll = Math.round(track.scrollLeft);

    root.classList.toggle('is-static', maxScroll <= 2);
    prev.classList.toggle(
      'is-disabled',
      currentScroll <= 2
    );
    next.classList.toggle(
      'is-disabled',
      currentScroll >= maxScroll - 2
    );
  }

  function syncMoreButtonHeight(root) {
    if (!root) return;

    const moreButton = root.querySelector(
      '[data-sib-pdp-toggle]'
    );

    const firstItem = root.querySelector(
      '.l51-sib-pdp__item'
    );

    if (!moreButton || !firstItem) return;

    const height = firstItem.offsetHeight;

    if (height > 0) {
      moreButton.style.height = `${height}px`;
    }
  }

  function setPdpToggleState(
    root,
    expanded,
    syncItems = true
  ) {
    if (!root) return;

    const button = root.querySelector(
      '[data-sib-pdp-toggle]'
    );

    if (!button) return;

    const countNode = button.querySelector(
      '.l51-sib-pdp__more-count'
    );

    const textNode = button.querySelector(
      '.l51-sib-pdp__more-text'
    );

    const moreCount =
      button.getAttribute('data-more-count') || '';

    button.setAttribute(
      'aria-expanded',
      expanded ? 'true' : 'false'
    );

    button.classList.toggle(
      'is-less-mode',
      expanded
    );

    if (countNode) {
      countNode.textContent = expanded
        ? `-${moreCount}`
        : `+${moreCount}`;
    }

    if (textNode) {
      textNode.textContent = expanded
        ? 'Ver menos'
        : 'Mostrar';
    }

    if (!syncItems) return;

    root
      .querySelectorAll(
        '.is-extra[data-sib-pdp-item]'
      )
      .forEach(function (item) {
        item.hidden = !expanded;
        item.classList.remove('is-collapsing');
        item.style.removeProperty('opacity');
        item.style.removeProperty('transform');
      });
  }

  function animatePdpToggle(root, expand) {
    if (!root) return;

    const grid = root.querySelector(
      '.l51-sib-pdp__grid'
    );

    if (!grid) {
      setPdpToggleState(root, expand);
      syncMoreButtonHeight(root);
      return;
    }

    if (grid.dataset.animating === 'true') return;

    grid.dataset.animating = 'true';

    const extraItems = Array.from(
      root.querySelectorAll(
        '.is-extra[data-sib-pdp-item]'
      )
    );

    const duration = 320;

    function cleanup() {
      grid.style.removeProperty('height');
      grid.style.removeProperty('overflow');
      grid.style.removeProperty('transition');
      grid.dataset.animating = 'false';

      extraItems.forEach(function (item) {
        item.classList.remove('is-collapsing');
        item.style.removeProperty('opacity');
        item.style.removeProperty('transform');

        if (!expand) {
          item.hidden = true;
        }
      });

      setPdpToggleState(root, expand, false);
      syncMoreButtonHeight(root);
    }

    if (expand) {
      const startHeight = grid.offsetHeight;

      extraItems.forEach(function (item) {
        item.hidden = false;
        item.style.opacity = '0';
        item.style.transform = 'scale(.96)';
      });

      setPdpToggleState(root, true, false);
      syncMoreButtonHeight(root);

      const endHeight = grid.scrollHeight;

      grid.style.height = `${startHeight}px`;
      grid.style.overflow = 'hidden';
      grid.style.transition =
        'height 320ms cubic-bezier(.22,.61,.36,1)';

      grid.getBoundingClientRect();

      requestAnimationFrame(function () {
        grid.style.height = `${endHeight}px`;

        extraItems.forEach(function (item) {
          item.style.opacity = '1';
          item.style.transform = 'scale(1)';
        });
      });

      const onTransitionEnd = function (event) {
        if (
          event.target !== grid ||
          event.propertyName !== 'height'
        ) {
          return;
        }

        grid.removeEventListener(
          'transitionend',
          onTransitionEnd
        );

        cleanup();
      };

      grid.addEventListener(
        'transitionend',
        onTransitionEnd
      );

      setTimeout(function () {
        if (grid.dataset.animating === 'true') {
          cleanup();
        }
      }, duration + 120);

      return;
    }

    const startHeight = grid.offsetHeight;

    setPdpToggleState(root, false, false);
    syncMoreButtonHeight(root);

    extraItems.forEach(function (item) {
      item.hidden = true;
    });

    const endHeight = grid.scrollHeight;

    extraItems.forEach(function (item) {
      item.hidden = false;
    });

    grid.style.height = `${startHeight}px`;
    grid.style.overflow = 'hidden';
    grid.style.transition =
      'height 320ms cubic-bezier(.22,.61,.36,1)';

    grid.getBoundingClientRect();

    requestAnimationFrame(function () {
      extraItems.forEach(function (item) {
        item.classList.add('is-collapsing');
      });

      requestAnimationFrame(function () {
        grid.style.height = `${endHeight}px`;
      });
    });

    const onTransitionEnd = function (event) {
      if (
        event.target !== grid ||
        event.propertyName !== 'height'
      ) {
        return;
      }

      grid.removeEventListener(
        'transitionend',
        onTransitionEnd
      );

      cleanup();
    };

    grid.addEventListener(
      'transitionend',
      onTransitionEnd
    );

    setTimeout(function () {
      if (grid.dataset.animating === 'true') {
        cleanup();
      }
    }, duration + 120);
  }

  function initGrid(root) {
    if (!root) return;
    if (root.dataset.sibReady === 'true') return;

    const track = root.querySelector(
      '[data-sib-grid-track]'
    );

    if (!track) return;

    root.dataset.sibReady = 'true';

    track.addEventListener(
      'scroll',
      function () {
        updateGridState(root);
      },
      { passive: true }
    );

    requestAnimationFrame(function () {
      updateGridState(root);
    });

    setTimeout(function () {
      updateGridState(root);
    }, 80);

    setTimeout(function () {
      updateGridState(root);
    }, 220);
  }

  function initPdp(root) {
    if (!root) return;
    if (root.dataset.sibPdpReady === 'true') return;

    root.dataset.sibPdpReady = 'true';

    setPdpToggleState(root, false);

    requestAnimationFrame(function () {
      syncMoreButtonHeight(root);
    });

    setTimeout(function () {
      syncMoreButtonHeight(root);
    }, 80);
  }

  function initAll(scope) {
    const context = scope || document;

    /*
     * Si el propio scope es un grid o PDP, también lo
     * inicializamos. querySelectorAll no incluye al scope.
     */
    if (context instanceof Element) {
      if (context.matches(SEL_GRID)) {
        initGrid(context);
      }

      if (context.matches(SEL_PDP)) {
        initPdp(context);
      }
    }

    context
      .querySelectorAll(SEL_GRID)
      .forEach(initGrid);

    context
      .querySelectorAll(SEL_PDP)
      .forEach(initPdp);
  }

  function initializeNewCard(card) {
    if (!card) return;

    initAll(card);

    requestAnimationFrame(function () {
      card
        .querySelectorAll(SEL_GRID)
        .forEach(updateGridState);

      card
        .querySelectorAll(SEL_PDP)
        .forEach(syncMoreButtonHeight);
    });
  }

  async function swapCardFromSibling(linkElement) {
    const currentCard = linkElement.closest(SEL_CARD);

    if (!currentCard) {
      console.warn(
        'No se encontró la card con data-crocs-product-card.'
      );
      return;
    }

    if (currentCard.dataset.siblingLoading === 'true') {
      return;
    }

    const siblingUrl =
      linkElement.getAttribute('href') || '';

    const handle = getHandleFromUrl(siblingUrl);

    if (!handle) {
      console.warn(
        'No se pudo obtener el handle del sibling:',
        siblingUrl
      );
      return;
    }

    let requestUrl;

    try {
      const url = new URL(
        siblingUrl,
        location.origin
      );

      /*
       * Fuerza el endpoint Crocs. No depende de la variable
       * global de Broadcast.
       */
      url.searchParams.set(
        'section_id',
        getSectionId(currentCard)
      );

      requestUrl = url.toString();
    } catch (error) {
      console.warn(
        'La URL del sibling no es válida:',
        siblingUrl
      );
      return;
    }

    currentCard.dataset.siblingLoading = 'true';
    currentCard.classList.add('is-loading');
    currentCard.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(requestUrl, {
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error(
          `La sección respondió con HTTP ${response.status}`
        );
      }

      const html = await response.text();

      const parsedDocument =
        new DOMParser().parseFromString(
          html,
          'text/html'
        );

      const apiContent =
        parsedDocument.querySelector(
          '[data-api-content]'
        );

      if (!apiContent) {
        throw new Error(
          'No se encontró [data-api-content] en api-crocs-product-item.'
        );
      }

      const newCard =
        apiContent.querySelector(SEL_CARD);

      if (!newCard) {
        throw new Error(
          'api-crocs-product-item no devolvió [data-crocs-product-card].'
        );
      }

      /*
       * Eliminamos estados que no deben copiarse a la card nueva.
       */
      newCard.classList.remove('is-loading');
      newCard.removeAttribute('aria-busy');
      delete newCard.dataset.siblingLoading;

      /*
       * Usamos replaceWith directamente. La función de transición
       * de Broadcast está diseñada para su product-item original
       * y puede asumir una estructura diferente.
       */
      currentCard.replaceWith(newCard);

      initializeNewCard(newCard);
    } catch (error) {
      console.warn(
        'Swap de sibling Crocs falló:',
        error
      );

      /*
       * Si falla el AJAX, navegamos al producto para que el clic
       * siga funcionando.
       */
      window.location.href = siblingUrl;
    } finally {
      /*
       * currentCard puede estar desconectada si el swap funcionó,
       * pero limpiar sus estados no causa problemas.
       */
      currentCard.classList.remove('is-loading');
      currentCard.removeAttribute('aria-busy');
      delete currentCard.dataset.siblingLoading;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const toggleButton = event.target.closest(
        '[data-sib-pdp-toggle]'
      );

      const previousButton = event.target.closest(
        '[data-sib-grid-prev]'
      );

      const nextButton = event.target.closest(
        '[data-sib-grid-next]'
      );

      const siblingLink = event.target.closest(
        SEL_GRID_SIBLING
      );

      if (toggleButton) {
        const root = toggleButton.closest(SEL_PDP);
        if (!root) return;

        const expanded =
          toggleButton.getAttribute(
            'aria-expanded'
          ) === 'true';

        animatePdpToggle(root, !expanded);
        return;
      }

      if (previousButton) {
        const root =
          previousButton.closest(SEL_GRID);

        const track =
          root?.querySelector(
            '[data-sib-grid-track]'
          );

        if (!track) return;

        track.scrollBy({
          left: -(getStep(track) * 3),
          behavior: 'smooth'
        });

        return;
      }

      if (nextButton) {
        const root =
          nextButton.closest(SEL_GRID);

        const track =
          root?.querySelector(
            '[data-sib-grid-track]'
          );

        if (!track) return;

        track.scrollBy({
          left: getStep(track) * 3,
          behavior: 'smooth'
        });

        return;
      }

      if (siblingLink) {
        const siblingGrid =
          siblingLink.closest(SEL_GRID);

        /*
         * El cambio AJAX solo se realiza dentro de una card.
         * En la ficha de producto se mantiene la navegación normal.
         */
        const card =
          siblingLink.closest(SEL_CARD);

        if (!siblingGrid || !card) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        swapCardFromSibling(siblingLink);
      }
    },
    true
  );

  let resizeFrame = null;

  window.addEventListener('resize', function () {
    if (resizeFrame) {
      cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = requestAnimationFrame(
      function () {
        document
          .querySelectorAll(SEL_GRID)
          .forEach(updateGridState);

        document
          .querySelectorAll(SEL_PDP)
          .forEach(syncMoreButtonHeight);
      }
    );
  });

  function initializeDocument() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeDocument,
      { once: true }
    );
  } else {
    initializeDocument();
  }

  const observer = new MutationObserver(
    function (mutations) {
      let shouldInitialize = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(
          function (node) {
            if (!(node instanceof Element)) return;

            if (
              node.matches(
                `${SEL_GRID}, ${SEL_PDP}, ${SEL_CARD}`
              ) ||
              node.querySelector(
                `${SEL_GRID}, ${SEL_PDP}, ${SEL_CARD}`
              )
            ) {
              shouldInitialize = true;
            }
          }
        );
      });

      if (!shouldInitialize) return;

      initAll(document);

      requestAnimationFrame(function () {
        document
          .querySelectorAll(SEL_GRID)
          .forEach(updateGridState);

        document
          .querySelectorAll(SEL_PDP)
          .forEach(syncMoreButtonHeight);
      });
    }
  );

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();